import { Pako } from "./pako.service";
import { HTTPService } from "./http.service";
import { DacConfig } from "./dac-config.service";
import { UniqueIdService } from "./unique-id.service";
import { AssessmentResultHydrator } from "./assessment-result-hydrator.service";
import { AssessmentHydrator } from "./assessment-hydrator.service";
import { AssessmentCompressorService } from "./assessment-compressor.service";
var AssessmentService = /** @class */ (function () {
    function AssessmentService(
        // TODO: stephen replace $http here with our dac$http
        _dac$http, _pako, _resultHydrator, _hydrator, _compressor, _uuid, dacConfig) {
        this._dac$http = _dac$http;
        this._pako = _pako;
        this._resultHydrator = _resultHydrator;
        this._hydrator = _hydrator;
        this._compressor = _compressor;
        this._uuid = _uuid;
        this.dacConfig = dacConfig;
        this.API_URL = this.dacConfig.api_url;
        this._results = new Map();
        this._assessments = new Map();
        this._pendingResults = new Map();
    }
    // TODO: stephen need to handle the caching results.
    AssessmentService.prototype.clearCache = function () {
        this._results = new Map();
        this._assessments = new Map();
        this._pendingResults = new Map();
    };
    Object.defineProperty(AssessmentService.prototype, "clientId", {
        get: function () {
            return this._clientId;
        },
        set: function (v) {
            this._clientId = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentService.prototype, "clientCustomField1", {
        get: function () {
            return this._clientCustomField1;
        },
        set: function (v) {
            this._clientCustomField1 = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentService.prototype, "uid", {
        get: function () {
            return this._assessmentUid;
        },
        set: function (v) {
            this._assessmentUid = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentService.prototype, "forceTestRetake", {
        get: function () {
            return this._forceTestRetake;
        },
        set: function (v) {
            this._forceTestRetake = v;
        },
        enumerable: true,
        configurable: true
    });
    AssessmentService.prototype.newId = function () {
        return this._uuid.generate();
    };
    AssessmentService.prototype.createAssessmentFromJSON = function (data) {
        return this._hydrator.hydrate(data);
    };
    AssessmentService.prototype.createAssessmentResultFromJSON = function (data) {
        return this._resultHydrator.hydrate(data);
    };
    AssessmentService.prototype.hasClientTakenAssessment = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.forceTestRetake) {
                resolve();
            }
            _this.getLatestClientAssessmentResult(_this.clientId, _this._assessmentUid)
                .then(function (result) {
                resolve(result.id);
            }, function (error) {
                if (error && error.status === 404) {
                    resolve();
                }
                else {
                    console.error("could not retrieve assessment results", error);
                    reject("could not retrieve assessment results");
                }
            });
        });
    };
    AssessmentService.prototype.getAssessmentForAssignment = function (assignment) {
        var _this = this;
        var requestData = {
            clientID: this.clientId,
            assignmentItemID: assignment.Id
        };
        // TODO: stephen is this going to cause problems here??
        return this._dac$http.get("assessments/" + assignment.Uid + ".json", requestData)
            .then(function (response) {
            var json = response.json();
            var assessment = _this.createAssessmentFromJSON(json);
            _this._assessments[assignment.Uid] = assessment;
            return assessment;
        });
    };
    AssessmentService.prototype.getAssessmentVersion = function (uid, version) {
        var _this = this;
        var requestData = {
            clientID: this.clientId,
            version: version
        };
        return this._dac$http.get("assessments/" + uid + ".json", requestData)
            .then(function (response) {
            var json = response.json();
            var assessment = _this.createAssessmentFromJSON(json);
            return assessment;
        }, function (error) {
            console.error(error);
            throw Error("could not retrieve assessment");
        });
    };
    AssessmentService.prototype.getAssessment = function (uid) {
        var _this = this;
        var that = this;
        if (this._assessments[uid]) {
            return Promise.resolve(this._assessments[uid]);
        }
        var requestData = {
            clientID: this.clientId
        };
        return this._dac$http.get("assessments/" + uid + ".json", requestData)
            .then(function (response) {
            var json = response.json();
            var assessment = that.createAssessmentFromJSON(json);
            _this._assessments[uid] = assessment;
            return assessment;
        }, function (error) {
            console.error(error);
            throw Error("could not retrieve assessment");
        });
    };
    AssessmentService.prototype.getAssessmentList = function () {
        var _this = this;
        return this._dac$http.get("assessments")
            .then(function (response) {
            var data = response.json();
            if (data) {
                var assessments = data.map(function (i) { return _this.createAssessmentFromJSON(i); })
                    .filter(function (a) { return _this.dacConfig.isAssessmentEnabled(a.uid); });
                return assessments;
            }
            throw new Error("No assessment data was returned");
        });
    };
    // TODO: stephen this compressed post is a leaky abstraction and doesn't work like the others
    // we need to fix it.
    AssessmentService.prototype.createAssessment = function (assessment) {
        var compressedAssessment = this._compressor.compress(assessment);
        return this._dac$http.compressedPost("assessments", compressedAssessment)
            .catch(function (error) {
            console.error(error);
            throw error.response;
        });
    };
    AssessmentService.prototype.saveAssessment = function (assessment) {
        var compressedAssessment = this._compressor.compress(assessment);
        return this._dac$http.compressedPost("assessments/" + assessment.uid + ".json", compressedAssessment)
            .then(function (result) {
            return result;
        })
            .catch(function (error) {
            console.error(error);
            throw error.response;
        });
    };
    AssessmentService.prototype.saveAssessmentResult = function (result) {
        var _this = this;
        var that = this;
        if (!result.id) {
            result.id = this.newId();
        }
        var saveData = {
            id: result.id,
            client_id: this.clientId,
            data: this.getAssessmentResultForSave(result),
            assessment: {
                id: result.assessment.id,
                uid: result.assessment.uid,
                version: result.assessment.version
            },
            client_custom_field_1: this.clientCustomField1
        };
        return this._dac$http.compressedPost("assessments/results.json", saveData)
            .then(function (response) {
            _this._results[result.id] = result;
            //this._$localStorage.result = result;
            _this.forceTestRetake = false;
            // turn off the test retake if we have saved the result
            return result;
        }, function (error) {
            console.error("save failed", error);
            throw new Error("Save results failed");
        });
    };
    AssessmentService.prototype.getAssessmentResultForSave = function (result) {
        var transformed = {
            _id: result.id,
            _assignmentItemId: result.assignmentItemId,
            _assessment: {
                _id: result.assessment.id,
                _uid: result.assessment.uid,
                _version: result.assessment.version
            },
            _scaleResults: [],
            _answers: [],
            _flaggedQuestions: result.flaggedQuestions.map(function (q) { return q.id; })
        };
        var scaleResults = result.scaleResults.map(function (sr) {
            if (!(sr.scale && sr.range)) {
                console.error("ScaleResult missing scale or range.  Check assessment data.  Object: ", sr);
            }
            return {
                _scaleId: sr.scale ? sr.scale.id : null,
                _score: sr.score,
                _rangeId: sr.range ? sr.range.id : null
            };
        });
        transformed._scaleResults = scaleResults;
        var questionSets = result.assessment.getQuestionSetsForDisplay();
        questionSets.forEach(function (qs) { return qs.questions.forEach(function (q) {
            transformed._answers.push({ _question_id: q.id, _answer: q.answerForSave, _score: q.getComputedScore() });
        }); });
        return transformed;
    };
    AssessmentService.prototype.resolvePendingResults = function (resultID, serverResponse) {
        var data = serverResponse.json();
        var result = this.createAssessmentResultFromJSON(data);
        // get it from the assessment if we didn't get one in our bound parameters
        // this only happens when a client first comes to an assessment and we don't know
        // their top result.
        if (!resultID) {
            resultID = result.id;
        }
        this._results[resultID] = result;
        if (!this._pendingResults[resultID]) {
            return;
        }
        this._pendingResults[resultID].forEach(function (defer) { return defer.resolve(result); });
        delete this._pendingResults[resultID];
    };
    AssessmentService.prototype.addPendingDefer = function (defer, resultID) {
        if (!this._pendingResults[resultID]) {
            this._pendingResults[resultID] = [];
        }
        this._pendingResults[resultID].push(defer);
    };
    AssessmentService.prototype.getLatestClientAssessmentResult = function (clientId, assessmentUID) {
        var _this = this;
        var requestData = {
            clientID: clientId,
            assessmentUID: assessmentUID,
            resultID: null
        };
        return new Promise(function (resolve, reject) {
            _this._dac$http.get("assessments/results.json", requestData)
                .then(function (serverResponse) {
                var data = serverResponse.json();
                var result = _this.createAssessmentResultFromJSON(data);
                _this._results[result.id] = result;
                resolve(result);
                return result;
            }, function (error) {
                reject(error);
                return error;
            });
        });
    };
    AssessmentService.prototype.getAssessmentResult = function (clientId, resultID) {
        var _this = this;
        var requestData = {
            clientID: clientId,
        };
        if (resultID) {
            requestData.resultID = resultID;
        }
        else {
            requestData.assessmentUID = this.uid;
        }
        console.log("attempting to grab results");
        return this._dac$http.get("assessments/results.json", requestData)
            .then(function (serverResponse) {
            var data = serverResponse.json();
            var result = _this.createAssessmentResultFromJSON(data);
            return result;
        });
        // 	let promise = new Promise((resolve, reject) => {
        // 		this._dac$http.get("assessments/results.json", requestData)
        // 		.then((serverResponse) => {
        // 			let data = serverResponse.json() as any;
        // 				var result:AssessmentResult = this.createAssessmentResultFromJSON(data);
        // 				// get it from the assessment if we didn't get one in our bound parameters
        // 				// this only happens when a client first comes to an assessment and we don't know
        // 				// their top result.
        // 				if (!resultID) {
        // 					resultID = result.id;
        // 				}
        // 		}, (error) => {
        // 			reject(error);
        // 			return error;
        // 		});
        // 		console.log("promise is: ", promise);
        // 		if (resultID && this._results[resultID]) {
        // 			resolve(this._results[resultID]);
        // 		}
        // 		else if (resultID && this._pendingResults[resultID]) {
        // 			this.addPendingDefer(promise, resultID);
        // 		}
        // 		else {
        // 			var requestData = {
        // 				clientID: clientId
        // 				,assessmentUID: this.uid
        // 				,resultID: null
        // 			};
        // 			let errorCallback = (error) => {
        // 				reject(error);
        // 				return error;
        // 			};
        // 			if (resultID) {
        // 				requestData.resultID = resultID;
        // 				this.addPendingDefer(promise, resultID);			
        // 			}
        // 			this._dac$http.get("assessments/results.json", requestData)
        // 					.then(this.resolvePendingResults.bind(this, resultID), errorCallback);
        // 		}
        // 	});
        // 	return promise;
        // }
        // clearResultCache() {
        // // does nothing as we have no caching layer at this point
        // // TODO: stephen look at removing this function.
    };
    return AssessmentService;
}());
export { AssessmentService };



// WEBPACK FOOTER //
// ./src/app/shared/services/assessment.service.ts.pre-build-optimizer.js